import React from 'react';

const Tooltip = ({ children, content, placement = 'top', className = '', style = {} }) => {
  const placementClass = `tooltip--${placement}`;
  return (
    <div className={`tooltip ${placementClass} ${className}`.trim()} style={style}>
      <div className="tooltip__trigger">{children}</div>
      <div className="tooltip__bubble" role="tooltip">
        <div className="tooltip__arrow" />
        <div className="tooltip__inner">{content}</div>
      </div>
    </div>
  );
};

export default Tooltip;
